import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { castelist, religionlist, subcastelist } from "../../../services/master";
import { grouplist, membercreate, memberdetail } from "../../../services/admin";
import { toast } from "react-toastify";
import ImageUrl from "../../../ImageUrl";
import Select from "react-select";

export default function Addmember() {
  const navigate = useNavigate();
  const { id, gid } = useParams();
  const [urllink, setUrllink] = useState("");
  const [mname, setMName] = useState("");
  const [mdob, setMDob] = useState("");
  const [mage, setMAge] = useState("");
  const [hname, setHName] = useState("");
  const [hdob, setHDob] = useState("");
  const [hage, setHAge] = useState("");
  const [phone, setPhone] = useState("");
  const [aphone, setAPhone] = useState("");

  const [aadno, setAadno] = useState("");
  const [mplace, setMPlace] = useState("");
  const [pfile, setPFile] = useState("");
  const [purl, setPUrl] = useState("");

  const [srel, setSRel] = useState("");
  const [rlist, setRList] = useState([]);

  const [scaste, setSCaste] = useState("");
  const [sclist, setSCList] = useState([]);
  const [subcas, setSubCas] = useState("");
  const [sublist, setSubList] = useState([]);

  const [mdetail, setMDetail] = useState("");
  const [hdetail, setHDetail] = useState("");
  const [paddr, setPAddr] = useState("");
  const [taddr, setTAddr] = useState("");
  const [occu, setOccu] = useState("");
  const [idaily, setIDaily] = useState("");
  const [imonth, setIMonth] = useState("");
  const [iwdays, setIWDays] = useState("");
  const [anninc, setAnnInc] = useState("");

  const [lincome, setLIncome] = useState("");
  const [pincome, setPIncome] = useState("");
  const [oincome, setOIncome] = useState("");
  const [ototal, setOTotal] = useState("");

  const [ohouse, setOHouse] = useState("");
  const [rhouse, setRHouse] = useState("");
  const [lhouse, setLHouse] = useState("");
  const [oassets, setOAssets] = useState("");

  const [mgroup, setMGroup] = useState("");
  const [glist, setGList] = useState([]);
  const [efee, setEFee] = useState("");


  let arr = [];

  function LetterOnly(eve) {
    if (/^[a-zA-Z\s]*$/.test(eve.key)) {
      return true;
    } else {
      eve.preventDefault();
      return false;
    }
  }

  function onPasteLetter(e) {
    const str = e.clipboardData.getData("Text");
    const newStr = str.replace(/[+-.]/g, "");
    if (str !== newStr) {
      e.preventDefault();
    }
  }
  const location = useLocation();

  useEffect(() => {

    const path = location.pathname.split("/")[2];
    setUrllink(path);

    if (path === "memberdetail" || path === "groupmemberdetail") {
      memberdetail(id).then((res) => {
        if (res.status === true) {
          if (res.data.details !== null) {
            if (res.data.details.member_name !== null) {
              setMName(res.data.details.member_name);
            }
            if (res.data.details.member_dob !== null) {
              setMDob(res.data.details.member_dob);
            }
            if (res.data.details.member_age !== null) {
              setMAge(res.data.details.member_age);
            }
            if (res.data.details.husband_name !== null) {
              setHName(res.data.details.husband_name);
            }
            if (res.data.details.husband_dob !== null) {
              setHDob(res.data.details.husband_dob);
            }
            if (res.data.details.husband_age !== null) {
              setHAge(res.data.details.husband_age);
            }
            if (res.data.details.phone_no !== null) {
              setPhone(res.data.details.phone_no);
            }
            if (res.data.details.alternate_no !== null) {
              setAPhone(res.data.details.alternate_no);
            }
            if (res.data.details.aadhar_no !== null) {
              setAadno(res.data.details.aadhar_no);
            }
            if (res.data.details.native_place !== null) {
              setMPlace(res.data.details.native_place);
            }
            if (res.data.details.religion_id !== null) {
              setSRel(res.data.details.religion_id);
            }
            if (res.data.details.caste_id !== null) {
              setSCaste(res.data.details.caste_id);
            }
            if (res.data.details.subcaste_id !== null) {
              setSubCas(res.data.details.subcaste_id);
            }
            if (res.data.details.member_detail !== null) {
              setMDetail(res.data.details.member_detail);
            }
            if (res.data.details.husband_detail !== null) {
              setHDetail(res.data.details.husband_detail);
            }
            if (res.data.details.permanent_address !== null) {
              setPAddr(res.data.details.permanent_address);
            }
            if (res.data.details.temporary_address !== null) {
              setTAddr(res.data.details.temporary_address);
            }
            if (res.data.details.occupation !== null) {
              setOccu(res.data.details.occupation);
            }
            if (res.data.details.daily_income !== null) {
              setIDaily(res.data.details.daily_income);
            }
            if (res.data.details.monthly_income !== null) {
              setIMonth(res.data.details.monthly_income);
            }
            if (res.data.details.working_days !== null) {
              setIWDays(res.data.details.working_days);
            }
            if (res.data.details.annual_income !== null) {
              setAnnInc(res.data.details.annual_income);
            }
            if (res.data.details.nancei_income !== null) {
              setLIncome(res.data.details.nancei_income);
            }
            if (res.data.details.puncei_income !== null) {
              setPIncome(res.data.details.puncei_income);
            }
            if (res.data.details.other_income !== null) {
              setOIncome(res.data.details.other_income);
            }
            if (res.data.details.overall_total !== null) {
              setOTotal(res.data.details.overall_total);
            }
            if (res.data.details.own_house !== null) {
              setOHouse(res.data.details.own_house);
            }
            if (res.data.details.rent_house !== null) {
              setRHouse(res.data.details.rent_house);
            }
            if (res.data.details.lease_house !== null) {
              setLHouse(res.data.details.lease_house);
            }
            if (res.data.details.other_assets !== null) {
              setOAssets(res.data.details.other_assets);
            }
            if (res.data.details.group_id !== null) {
              // setMGroup(res.data.details.group_id);
              const temp = new FormData();
              temp.append("branch", localStorage.getItem("branch"));
              grouplist(temp).then((res1) => {
                if (res1.status === true) {
                  let arr=[];
                  if (res1.data.length > 0) {
                    for (let i = 0; i < res1.data.length; i++) {
                      if(res1.data[i].id == res.data.details.group_id){
                        arr.push({
                            value: res1.data[i].id,
                            label: res1.data[i].group_name
                        })
                      }
                    }
                    setMGroup(arr[0]);
                }
                }
              })
            }
            if (res.data.details.entry_fee !== null) {
              setEFee(res.data.details.entry_fee);
            }
            if (res.data.photo !== null) {
              setPUrl(ImageUrl + res.data.path + res.data.details.photo);
            }
          }
        }
      })
    } else {
      setMName("");
      setMDob("");
      setMAge("");
      setHName("");
      setHDob("");
      setHAge("");
      setPhone("");
      setAPhone("");
      setAadno("");
      setMPlace("");
      setPFile("");
      setPUrl("");
      setSRel("");
      setSCaste("");
      setSubCas("");
      setMDetail("");
      setHDetail("");
      setPAddr("");
      setTAddr("");
      setOccu("");
      setIDaily("");
      setIMonth("");
      setIWDays("");
      setAnnInc("");
      setLIncome("");
      setPIncome("");
      setOIncome("");
      setOTotal("");
      setOHouse("");
      setRHouse("");
      setLHouse("");
      setOAssets("");
      setMGroup("");
      setEFee("");
    }

    religionlist().then((res) => {
      if (res.status === true) {
        setRList(res.data);
      }
    })

    castelist().then((res) => {
      if (res.status === true) {
        setSCList(res.data);
      }
    })

    subcastelist().then((res) => {
      if (res.status === true) {
        setSubList(res.data);
      }
    })
    const temp = new FormData();
    temp.append("branch", localStorage.getItem("branch"));
    grouplist(temp).then((res) => {
      if (res.status === true) {
        let arr=[];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
              arr.push({
                  value: res.data[i].id,
                  label: res.data[i].group_name
              })
          }
          setGList(arr);
      }
      }
    })


  }, [location.pathname]);

  const handleMAge = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setMAge(e.target.value);
    }
  };

  const handleHAge = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setHAge(e.target.value);
    }
  };
  const handleChange = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setPhone(e.target.value);
    }
  };

  const handleAadhar = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setAadno(e.target.value);
    }
  };

  const handleAChange = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setAPhone(e.target.value);
    }
  };

  const handleDaily = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setIDaily(e.target.value);
    }
  };
  const handleMonth = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setIMonth(e.target.value);
    }
  };
  const handleDays = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setIWDays(e.target.value);
    }
  };

  const handleAnnual = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setAnnInc(e.target.value);
    }
  };

  const handleNIncome = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setLIncome(e.target.value);
    }
  };

  const handlePIncome = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setPIncome(e.target.value);
    }
  };

  const handleOther = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setOIncome(e.target.value);
    }
  };

  const handleTotal = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setOTotal(e.target.value);
    }
  };

  const handleFee = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setEFee(e.target.value);
    }
  };



  const [photoerror, setPhotoError] = useState("");
  function photofile(event) {
    setPhotoError("");
    setPFile("");
    if (event.target.files.length !== 0) {
      if (event.target.files[0].name.match(/\.(jpg|jpeg|png)$/i)) {
        setPUrl(URL.createObjectURL(event.target.files[0]));
        setPFile(event.target.files[0]);
      } else {
        setPhotoError("Photo should be jpg, jpeg, or png format");
      }
      var size = event.target.files[0].size / 1024 / 1024;
      if (size > 5) {
        setPhotoError("Photo size should be less than 5MB");
      }
    }
  }

  function errorphoto(ev) {
    ev.target.src = require("../../../assets/images/women.png");
    ev.target.onerror = null;
  }

  const [errmsg, setError] = useState("");
  const [successmsg, setSuccess] = useState(false);
  function submitmem(e) {
    e.preventDefault();
    setSuccess(true);
    var valid = "";
    if (mname !== "" && mdob !== "" && mage !== "" && phone !== "" && aadno !== "" && mplace !== "" && srel !== "" && scaste !== "" && subcas !== "" && ohouse !== "" && rhouse !== "" && lhouse !== "" && mgroup !== "" && efee !== "") {
      setLoading(true);
      const temp = new FormData();
      temp.append("member_name", mname);
      temp.append("member_dob", mdob);
      temp.append("member_age", mage);
      temp.append("husband_name", hname);
      temp.append("husband_dob", hdob);
      temp.append("husband_age", hage);
      temp.append("phone_no", phone);
      temp.append("alternate_no", aphone);
      temp.append("aadhar_no", aadno);
      temp.append("native_place", mplace);
      temp.append("religion_id", srel);
      temp.append("caste_id", scaste);
      temp.append("subcaste_id", subcas);
      temp.append("member_detail", mdetail);
      temp.append("husband_detail", hdetail);
      temp.append("permanent_address", paddr);
      temp.append("temporary_address", taddr);
      temp.append("occupation", occu);
      temp.append("daily_income", idaily);
      temp.append("monthly_income", imonth);
      temp.append("working_days", iwdays);
      temp.append("annual_income", anninc);
      temp.append("nancei_income", lincome);
      temp.append("puncei_income", pincome);
      temp.append("other_income", oincome);
      temp.append("overall_total", ototal);
      temp.append("own_house", ohouse);
      temp.append("rent_house", rhouse);
      temp.append("lease_house", lhouse);
      temp.append("other_assets", oassets);
      temp.append("group_id", mgroup.value);
      temp.append("photo", pfile);
      temp.append("entry_fee", efee);

      if (urllink === "memberdetail" || urllink === "groupmemberdetail") {
        temp.append("id", id);
      }
      membercreate(temp).then((res) => {
        if (res.status === true) {
          setLoading(false);
          toast.success(res.message);
          if (urllink === "groupmemberdetail") {
            navigate(`/group/groupdetail/${gid}`);
          } else {
            navigate("/member/allmembers");
          }
        } else {
          setError(res.message);
        }
      })
    }
  }
  function backlist() {
    if (urllink === "groupmemberdetail") {
      navigate(`/group/groupdetail/${gid}`);
    } else {
      navigate("/member/allmembers");
    }
  }
  function handleGroup(e) {
    if(e !== null) {
      setMGroup(e);
    }else{
      setMGroup("");
    }
  }

  const [loading, setLoading] = useState(false);
  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">{urllink === "addmember" ? "Add Member" : "Member Detail"}</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Member</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            {urllink === "addmember" ? "Add Member" : "Member Detail"}
          </li>
        </ol>
      </div>

      {loading && (
        <div className="loader-wrapper">
          <div className="loader"></div>
          <h3>Loading...Please do not go back or close the window.</h3>
        </div>
      )}

      {!loading && (
        <div className="content-body">
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h2 className="main-content-title tx-24 mg-b-5">
                    {urllink === "addmember" ? "Add Member" : "Member Detail"}
                  </h2>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-3 col-lg-4">
                      <label className="form-label">Photo</label>
                      <div className="avatar-upload">
                        <div className="avatar-preview">
                          <img
                            alt="avatar"
                            src={purl}
                            onError={(e) => errorphoto(e)}
                          />
                        </div>
                        <div className="change-btn mt-2 mb-lg-0 mb-3">
                          <input
                            type="file"
                            className="form-control"
                            accept=".png, .jpg, .jpeg"
                            onChange={(e) => photofile(e)}
                          />
                          {photoerror !== "" && (
                            <span className="text-danger">{photoerror}</span>
                          )}

                          <a
                            className="btn btn-secondary my-2"
                            onClick={() => {
                              setPUrl("");
                              setPFile("");
                            }}
                          >
                            Remove
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-9 col-lg-8">
                      <div className="row">
                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Member Name
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Member Name"
                              value={mname}
                              onChange={(e) => setMName(e.target.value)}
                              onKeyPress={LetterOnly}
                              onPaste={onPasteLetter}
                            />
                            {successmsg && mname === "" && (
                              <span className="text-danger">
                                Please Enter Member Name
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Member DOB
                              <span className="text-danger"> * (dd/mm/yyyy)</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              value={mdob}
                              onChange={(e) => setMDob(e.target.value)}
                              placeholder="Enter Member DOB"
                              // onKeyPress={(event) => {
                              //   event.preventDefault();
                              // }}
                              // onKeyDown={(event) => {
                              //   event.preventDefault();
                              // }}
                            />
                            {successmsg && mdob === "" && (
                              <span className="text-danger">
                                Please Enter Member DOB
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Age
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Member Age"
                              value={mage}
                              onChange={handleMAge}
                            />
                            {successmsg && mage === "" && (
                              <span className="text-danger">
                                Please Enter Member Age
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Husband Name
                              {/* <span className="text-danger"> *</span> */}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Husband Name"
                              value={hname}
                              onChange={(e) => setHName(e.target.value)}
                              onKeyPress={LetterOnly}
                              onPaste={onPasteLetter}
                            />
                            {/* {successmsg && hname === "" && (
                              <span className="text-danger">
                                Please Enter Husband Name
                              </span>
                            )} */}
                          </div>
                        </div>
                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Husband DOB
                              <span className="text-danger"> (dd/mm/yyyy)</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              value={hdob}
                              onChange={(e) => setHDob(e.target.value)}
                              placeholder="Enter Husband DOB"
                              // onKeyPress={(event) => {
                              //   event.preventDefault();
                              // }}
                              // onKeyDown={(event) => {
                              //   event.preventDefault();
                              // }}
                            />
                            {/* {successmsg && hdob === "" && (
                              <span className="text-danger">
                                Please Enter Husband DOB
                              </span>
                            )} */}
                          </div>
                        </div>
                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Husband Age
                              {/* <span className="text-danger"> *</span> */}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Husband Age"
                              value={hage}
                              onChange={handleHAge}
                            />
                            {/* {successmsg && hage === "" && (
                              <span className="text-danger">
                                Please Enter Husband Age
                              </span>
                            )} */}
                          </div>
                        </div>

                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Phone Number{" "}
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Phone Number"
                              value={phone}
                              maxLength={10}
                              onChange={handleChange}
                              onPaste={(e) => {
                                e.preventDefault();
                                return false;
                              }}
                              onCopy={(e) => {
                                e.preventDefault();
                                return false;
                              }}
                            />
                            {successmsg && phone === "" && (
                              <span className="text-danger">
                                Please Enter Phone Number
                              </span>
                            )}
                            {phone !== "" && phone.length < 10 && (
                              <span className="text-danger">
                                Phone Number should be 10 digits
                              </span>
                            )}
                          </div>
                        </div>

                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Aadhar Number
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Aadhar Number"
                              maxLength={12}
                              value={aadno}
                              onChange={handleAadhar}
                              onPaste={(e) => {
                                e.preventDefault();
                                return false;
                              }}
                              onCopy={(e) => {
                                e.preventDefault();
                                return false;
                              }}
                            />
                            {successmsg && aadno === "" && (
                              <span className="text-danger">
                                Please Enter Aadhar Number
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Native Place
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Native Place"
                              value={mplace}
                              onChange={(e) => setMPlace(e.target.value)}
                            />
                            {successmsg && mplace === "" && (
                              <span className="text-danger">
                                Please Enter Native Place
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Religion <span className="text-danger"> *</span>
                            </label>
                            <select
                              className="default-select  form-control wide"
                              value={srel}
                              onChange={(e) => setSRel(e.target.value)}
                            >
                              <option value="" disabled>
                                Select Religion
                              </option>
                              {rlist.map((item, i) => {
                                return (
                                  <option value={item.id} key={i}>
                                    {item.religion_name}
                                  </option>
                                );
                              })}
                            </select>
                            {successmsg && srel === "" && (
                              <span className="text-danger">
                                Please Select Religion
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Caste <span className="text-danger"> *</span>
                            </label>
                            <select
                              className="default-select  form-control wide"
                              value={scaste}
                              onChange={(e) => setSCaste(e.target.value)}
                            >
                              <option value="" disabled>
                                Select Caste
                              </option>
                              {sclist.map((item, i) => {
                                return (
                                  <option value={item.id} key={i}>
                                    {item.caste_name}
                                  </option>
                                );
                              })}
                            </select>
                            {successmsg && scaste === "" && (
                              <span className="text-danger">
                                Please Select Caste
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Sub-Caste <span className="text-danger"> *</span>
                            </label>
                            <select
                              className="default-select  form-control wide"
                              value={subcas}
                              onChange={(e) => setSubCas(e.target.value)}
                            >
                              <option value="" disabled>
                                Select Sub-Caste
                              </option>
                              {sublist.map((item, i) => {
                                return (
                                  <option value={item.id} key={i}>
                                    {item.subcaste_name}
                                  </option>
                                );
                              })}
                            </select>
                            {successmsg && subcas === "" && (
                              <span className="text-danger">
                                Please Select Sub-Caste
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Alternate Number{" "}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Alternate Number"
                              value={aphone}
                              maxLength={10}
                              onChange={handleAChange}
                              onPaste={(e) => {
                                e.preventDefault();
                                return false;
                              }}
                              onCopy={(e) => {
                                e.preventDefault();
                                return false;
                              }}
                            />
                           
                            {aphone !== "" && aphone.length < 10 && (
                              <span className="text-danger">
                                Alternate Number should be 10 digits
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-xl-4 col-sm-4">
                          <div className="mb-3">
                            <label className="form-label">Member Detail</label>
                            <textarea
                              rows={3}
                              className="form-control"
                              placeholder="Enter Your Member Detail"
                              value={mdetail}
                              onChange={(e) => setMDetail(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-xl-4 col-sm-4">
                          <div className="mb-3">
                            <label className="form-label">Husband Detail</label>
                            <textarea
                              rows={3}
                              className="form-control"
                              placeholder="Enter Your Husband Detail"
                              value={hdetail}
                              onChange={(e) => setHDetail(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-xl-6 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Permanent Address
                            </label>
                            <textarea
                              rows={3}
                              className="form-control"
                              placeholder="Enter Your Permanent Address"
                              value={paddr}
                              onChange={(e) => setPAddr(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-xl-6 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Temporary Address
                            </label>
                            <textarea
                              rows={3}
                              className="form-control"
                              placeholder="Enter Your Temporary Address"
                              value={taddr}
                              onChange={(e) => setTAddr(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-12 mt-2">
              <div className="card">
                <div className="card-header">
                  <h2 className="main-content-title tx-24 mg-b-5">
                    Add Income Details
                  </h2>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Occupation</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Occupation"
                          value={occu}
                          onChange={(e) => setOccu(e.target.value)}
                        />

                      </div>
                    </div>
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Daily </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Daily income"
                          maxLength={10}
                          value={idaily}
                          onChange={handleDaily}
                        />

                      </div>
                    </div>
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Monthly</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Monthly Income"
                          maxLength={10}
                          value={imonth}
                          onChange={handleMonth}
                        />

                      </div>
                    </div>
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Working Days</label>
                        <input
                          type="text"
                          className="form-control"
                          maxLength={10}
                          placeholder="Enter Working Days"
                          value={iwdays}
                          onChange={handleDays}
                        />

                      </div>
                    </div>
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Annual Income</label>
                        <input
                          type="text"
                          className="form-control"
                          maxLength={10}
                          placeholder="Enter Annual Income"
                          value={anninc}
                          onChange={handleAnnual}
                        />

                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-header">
                  <h2 className="main-content-title tx-24 mg-b-5">
                    Add Land income
                  </h2>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Nansei Income</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Nansei Income"
                          value={lincome}
                          onChange={handleNIncome}
                        />

                      </div>
                    </div>
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Punsei Income</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Punsei Income"
                          value={pincome}
                          onChange={handlePIncome}
                          maxLength={10}
                        />

                      </div>
                    </div>
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Other Income</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Other Income"
                          value={oincome}
                          onChange={handleOther}
                        />

                      </div>
                    </div>
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Overall Total</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Total Income"
                          value={ototal}
                          onChange={handleTotal}
                        />

                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-header">
                  <h2 className="main-content-title tx-24 mg-b-5">
                    Add Asset Details
                  </h2>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Own House <span className="text-danger"> *</span>
                        </label>
                        <select
                          className="default-select  form-control wide"
                          value={ohouse}
                          onChange={(e) => setOHouse(e.target.value)}
                        >
                          <option value="" disabled>
                            Select Own House
                          </option>

                          <option value="Yes">Yes</option>
                          <option value="No">No</option>

                        </select>
                        {successmsg && ohouse === "" && (
                          <span className="text-danger">
                            Please Select Own House
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Rent House <span className="text-danger"> *</span>
                        </label>
                        <select
                          className="default-select  form-control wide"
                          value={rhouse}
                          onChange={(e) => setRHouse(e.target.value)}
                        >
                          <option value="" disabled>
                            Select Rent House
                          </option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>
                        {successmsg && rhouse === "" && (
                          <span className="text-danger">
                            Please Select Rent House
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">
                          {" "}
                          Lease House <span className="text-danger"> *</span>
                        </label>
                        <select
                          className="default-select  form-control wide"
                          value={lhouse}
                          onChange={(e) => setLHouse(e.target.value)}
                        >
                          <option value="" disabled>
                            Select Lease House
                          </option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>
                        {successmsg && lhouse === "" && (
                          <span className="text-danger">
                            Please Select Lease House
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Other Assets</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Other Assets"
                          value={oassets}
                          onChange={(e) => setOAssets(e.target.value)}
                        />
                        {successmsg && oassets === "" && (
                          <span className="text-danger">
                            Please Enter Other Assets
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-2">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h2 className="main-content-title tx-24 mg-b-5">
                    Add Group Detail
                  </h2>
                </div>
                <div className="card-body">
                  <div className="row">

                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Group<span className="text-danger"> *</span>
                        </label>
                        <Select
                          className="default-select"
                          placeholder="Select Select Group"
                          value={mgroup}
                          options={glist}
                          onChange={handleGroup}
                          isSearchable={true}
                          isClearable
                          hidden
                          isDisabled={urllink === "memberdetail" ? true : false}
                        />

                        {/* <select
                          className="default-select  form-control wide"
                          value={mgroup}
                          onChange={(e) => setMGroup(e.target.value)}
                        >
                          <option value="" disabled>
                            Select Group
                          </option>
                          {glist.map((item, i) => {
                            return (
                              <option value={item.id} key={i}>
                                {item.group_name}
                              </option>
                            );
                          })}
                        </select> */}
                        {successmsg && mgroup === "" && (
                          <span className="text-danger">
                            Please Select Group
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Entry Fee <span className="text-danger"> *</span> </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Entry Fee"
                          maxLength={10}
                          value={efee}
                          onChange={handleFee}
                        />
                        {successmsg && efee === "" && (
                          <span className="text-danger">
                            Please Enter Entry Fee
                          </span>
                        )

                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {errmsg !== "" && <span className="text-danger">{errmsg}</span>}
          <div className="res-right mt-2 me-4">
            <button className="btn btn-success me-2" onClick={submitmem}>
              Submit
            </button>
            {urllink === "memberdetail" || urllink === "groupmemberdetail" &&
              <button className="btn btn-secondary" onClick={backlist}>Back</button>
            }
          </div>
        </div>
      )}
    </div>
  );
}
